export enum INPUT_TYPE {
  DATE = 'date',
  TEXT = 'text',
  LICENCE_PLATE = 'licence-plate',
}
